module.exports = __webpack_public_path__ + "img/P49-zh.bb995dad.png";